@if (phasesCheckDone) {
  <router-outlet [dir]="dir"></router-outlet>
}
